import { protocolValueSets } from '@liza/protocols';
import { SURVEY_CONFIGS } from '../questionnaire/surveys';
import type { SurveyConfig } from '../questionnaire/surveys';
import {
  getLifestyleMeasurementDisplay,
  getLifestyleMeasurementDomain,
  getLifestyleMeasurementUnit,
  LIFESTYLE_MEASUREMENT_CONFIGS,
  LIFESTYLE_MEASUREMENTS_SYSTEM,
} from './lifestyleMeasurements';
import type { LifestyleMeasurementConfig, LifestyleMeasurementDomain, TargetComparator } from './lifestyleMeasurements';
import { lizaPrimaryCareLabs } from './lizaPrimaryCareLabs';
import { lizaPrimaryCareMedicationRoutes } from './lizaPrimaryCareMedicationRoutes';
import { lizaSurveysValueSet } from './lizaSurveys';
import { vitalSignsValueSet, VITAL_SIGN_CONFIGS } from './vitalSigns';
import type { VitalSignConfig } from './vitalSigns';

export {
  getLifestyleMeasurementDisplay,
  getLifestyleMeasurementDomain,
  getLifestyleMeasurementUnit,
  LIFESTYLE_MEASUREMENT_CONFIGS,
  LIFESTYLE_MEASUREMENTS_SYSTEM,
  lizaPrimaryCareLabs,
  lizaPrimaryCareMedicationRoutes,
  lizaSurveysValueSet,
  SURVEY_CONFIGS,
  vitalSignsValueSet,
  VITAL_SIGN_CONFIGS,
};
export type { LifestyleMeasurementConfig, LifestyleMeasurementDomain, SurveyConfig, TargetComparator, VitalSignConfig };

// Protocol terminology (RxNorm drug classes) is defined in `@liza/protocols` and deployed here.
export const valueSets = {
  ...protocolValueSets,
  lizaPrimaryCareLabs,
  lizaPrimaryCareMedicationRoutes,
  lizaSurveysValueSet,
  vitalSignsValueSet,
};
